import React from 'react';
import css from "./SecFive.module.scss";
import {Link} from "react-router-dom";
import {PORTFOLIO} from "../../../../Utils/Urls";
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import {useTranslation} from "react-i18next";

const SecFive = () => {

    const {t} = useTranslation();

    return (
        <section className={css.five}>
            <Link
                to={PORTFOLIO +"/printing"}
            >
                {t("portfolio")} <ArrowOutwardIcon/>
            </Link>
        </section>
    );
};

export default SecFive;